export function sortCriteriaGenerator(accessor) {
  return (a, b) => {
    const textA = accessor(a);
    const textB = accessor(b);
    if (typeof textA === "number") return textA - textB;
    return textA.localeCompare(textB);
  };
}
